export default __webpack_public_path__ + "static/media/master_setup.1234b267.svg";